import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from '@phosphor-icons/react';

import { Footer } from '@/components/layout/Footer/Footer';

import styles from './Privacy.module.css';

export function Privacy() {
    const navigate = useNavigate();

    useEffect(() => {
        document.title = 'Politica de Privacidad — Ratio';
    }, []);

    return (
        <div className={styles.page}>
            <div className={styles.container}>
                <button
                    className={styles.backBtn}
                    onClick={() => navigate(-1)}
                    aria-label="Volver"
                >
                    <ArrowLeft size={18} />
                    Volver
                </button>

                <h1 className={styles.title}>Politica de Privacidad</h1>
                <p className={styles.updated}>Ultima actualizacion: marzo 2026</p>

                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>Datos recopilados</h2>
                    <p className={styles.text}>
                        En Ratio recopilamos la informacion minima necesaria para el
                        funcionamiento de la plataforma:
                    </p>
                    <ul className={styles.list}>
                        <li>Nombre y apellido (proporcionado por tu cuenta de Google)</li>
                        <li>Direccion de correo electronico</li>
                        <li>Foto de perfil de Google (avatar)</li>
                        <li>Datos de actividad: encuestas creadas, votos emitidos y comentarios</li>
                        <li>Informacion tecnica: direccion IP, tipo de navegador y dispositivo</li>
                    </ul>
                </section>

                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>Uso de datos</h2>
                    <p className={styles.text}>Utilizamos tus datos para:</p>
                    <ul className={styles.list}>
                        <li>Autenticacion y gestion de tu cuenta</li>
                        <li>Mostrar tu perfil publico (nombre y avatar) junto a tus encuestas y comentarios</li>
                        <li>Mejorar la experiencia de usuario y la seguridad de la plataforma</li>
                        <li>Enviar notificaciones relacionadas con tu actividad (si las activas)</li>
                    </ul>
                    <p className={styles.text}>
                        No vendemos, alquilamos ni compartimos tus datos personales con terceros
                        con fines comerciales. Solo compartiremos informacion cuando sea requerido
                        por ley.
                    </p>
                </section>

                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>Cookies</h2>
                    <p className={styles.text}>
                        Ratio utiliza las siguientes cookies y mecanismos de almacenamiento local:
                    </p>
                    <ul className={styles.list}>
                        <li>
                            <strong>Token JWT:</strong> almacenado en localStorage para mantener tu
                            sesion activa de forma segura.
                        </li>
                        <li>
                            <strong>Preferencias de tema:</strong> almacenamos tu preferencia de
                            tema claro u oscuro para mejorar tu experiencia.
                        </li>
                    </ul>
                    <p className={styles.text}>
                        No utilizamos cookies de rastreo ni de terceros con fines publicitarios.
                    </p>
                </section>

                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>Derechos del usuario</h2>
                    <p className={styles.text}>
                        Como usuario de Ratio, tienes derecho a:
                    </p>
                    <ul className={styles.list}>
                        <li>
                            <strong>Acceso:</strong> solicitar una copia de los datos personales que
                            tenemos sobre ti.
                        </li>
                        <li>
                            <strong>Rectificacion:</strong> corregir datos inexactos o
                            desactualizados.
                        </li>
                        <li>
                            <strong>Eliminacion:</strong> solicitar la eliminacion de tu cuenta y
                            datos asociados.
                        </li>
                        <li>
                            <strong>Portabilidad:</strong> recibir tus datos en un formato
                            estructurado y de uso comun.
                        </li>
                    </ul>
                </section>

                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>Contacto</h2>
                    <p className={styles.text}>
                        Si tienes preguntas sobre esta politica de privacidad o deseas ejercer
                        alguno de tus derechos, puedes contactarnos en:{' '}
                        <a href="mailto:info@qolca.org" className={styles.link}>
                            info@qolca.org
                        </a>
                    </p>
                </section>
            </div>
            <Footer />
        </div>
    );
}
